import React, {Fragment} from "react";
import Select from "react-select";
import {formatGroupLabel} from "./DropdownDataProviders";
import ErrorDiv from "ui/ErrorDiv";

const isValid = () =>
{
    return true ;
}

const getCurrentText = ( value, data ) =>
{
    const entry = getEntryWithValue(value,data);

    return entry != null ? entry.label : '' ;
}

const getEntryWithValue = ( current, data ) =>
{
    if ( Array.isArray(current))
{
        const entry = data.filter ((listentry) =>
        {
            const match = current.find ( (alreadyset) => {
                return alreadyset == listentry.value;
            });

            if ( match !== undefined )
            {
                return true ;
            }
        })

    return entry  ;
}
    else
    {
        const entry = data.find ( element => element.value == current );

        return entry  ;
    }
}

export const renderDropdownReadOnly = (props, data) =>
{
    let style = {
        borderColor: '#d8e5ed',
        paddingLeft: '14px',
        color: '#428bcd'
    };

    const labelCLass = props.labelClassName === undefined ? '' : props.labelClassName ;

    return (
        <Fragment>
            <label htmlFor={props.name} className={labelCLass}>{props.label}</label>
            <input
                readOnly = 'readonly'
                type = 'text'
                className = 'form-control'
                value = {getCurrentText(props.value, data.items)}
                style = {style}
                id = {props.id}
                name = {props.name} />
        </Fragment>
    )
}

export const renderDropdown = (props, data, options) =>
{
    const onChange = ( a, b ) =>
    {
        props.onChange ( a,b ) ;
    }

    const isSearchable = options === null || options === undefined ? false : options.isSearchable === true ? true : false ;
    const isClearable = options === null || options === undefined ? false : options.isClearable === true ? true : false ;
    const isMulti = options === null || options === undefined ? false : options.isMulti === true ? true : false ;

    return (
        <Fragment>
            <div className={props.defaultClassName}>
                <label className='col-form-label' htmlFor={props.name}>{props.label}</label>
                <Select
                    key={JSON.stringify(data)}
                    onChange={onChange}
                    tabIndex={props.tabIndex}
                    defaultValue={getEntryWithValue(props.value, data.items)}
                    options={data.items}
                    isSearchable={isSearchable}
                    isClearable={isClearable}
                    isMulti={isMulti}
                    name={props.name}
                    formatGroupLabel={formatGroupLabel} />
                {props.renderErrorDiv && <ErrorDiv errorText={props.errorText} />}
            </div>
        </Fragment>

    )
}

